module.exports = __webpack_public_path__ + "img/向上签.e5127875.jpg";